import { jwtDecode } from 'jwt-decode'

import { setAuthToken } from '@/helpers/authToken'

const hasValidResource = token => {
  const { privileges } = jwtDecode(token)
  return !Array.isArray(privileges) || privileges.some(p => p.resource !== null)
}

export async function logInWithToken(token, { store, router }) {
  store.commit('RESET_STATE')
  setAuthToken(token)

  if (!hasValidResource(token)) return false

  await store.dispatch('getLoggedInUser').catch(() => {})
  window.pusherInit()
  router.push('/')
  return true
}
